import Individual from './individual/Statement';
import List from './list/Statements';

export default { List, Individual };
